<template>
  <div
    v-if="validDate && !welcomeTourMode && showNotification"
    class="notification-wrapper"
  >
    <Notification
      type="info"
      title="Oops! Data processing issues"
      :allowDismiss="true"
    >
      Between 30 September and 1 October 2020, we experienced some issues
      processing data from our honeynet sensors. This affects the totals in the
      'Overview' box for periods of time including those dates. In addition, for
      those dates, you will see zero hits in the charts of daily totals.
      Nevertheless, the general trend of suspicious traffic coming out of your
      network is still valid. Please accept our apologies for any inconvenience.
    </Notification>
  </div>
</template>

<script>
import mixin from '../../utils/mixin';
import { mapGetters } from 'vuex';
import Notification from '../ui/Notification';
export default {
  mixins: [mixin],

  computed: {
    ...mapGetters('dataStore', ['welcomeTourMode']),
    showNotification() {
      return this.selectedASN && !this.noAccount && !this.noData;
    },
    validDate() {
      return Date.now() < new Date('2021-01-31');
    }
  },
  components: {
    Notification
  }
};
</script>

<style lang="scss" scoped></style>
